const newCopiedProductReducer = (state = "", action) => {
    switch(action.type) {
        case 'SET_NEW_COPIED_PRODUCT':
            state = action.payload;
            return state;
        default:
            return state;
    }
}

export default newCopiedProductReducer;